var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.isIPhoneX || _vm.isIPhoneXSMax || _vm.isIPhoneXR ? 'tabBar fr ac jsa ipx_pb' : 'tabBar fr ac jsa'},[_c('router-link',{staticClass:"tab",attrs:{"to":"/"}},[_c('span')]),_vm._v(" "),_c('router-link',{staticClass:"tab",attrs:{"to":"/meIndex"}},[_c('span')])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34f58600","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/tabBar.vue
// module id = null
// module chunks = 